exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".msg__content[data-v-12e8e3b9]{display:-webkit-box;display:-ms-flexbox;display:flex}", "", {"version":3,"sources":["/home/webuser/profi-stout/releases/42/spa/src/pages/chat/components/Message/Message.scss"],"names":[],"mappings":"AACE,+BACE,oBAAA,oBAAA,YAAA,CAAA","file":"Message.scss?vue&type=style&index=0&id=12e8e3b9&prod&scoped=true&lang=scss&","sourcesContent":[".msg {\n  &__content {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);

// exports
